<template>
  <el-dialog
    modal-class="dialog-message-overlay"
    class="dialog-message"
    v-model="dialogVisible"
    :title="messageContent.title"
    :width="messageContent.width || '480px'"
    :before-close="handleClose"
    :close-on-click-modal="false"
    v-bind="$attrs"
  >
    <!-- 二次确认弹窗-默认 -->
    <div class="texts dialog-message-content">
      <div class="line" v-if="messageContent.showHeaderTBorder" />
      <template v-if="messageContent.isDefault">
        <el-icon class="warn-icon" :class="messageContent.type">
          <WarningFilled v-if="messageContent.type === 'warn'" />
          <SuccessFilled v-if="messageContent.type === 'success'" />
          <CircleCloseFilled v-if="messageContent.type === 'error'" />
        </el-icon>
        <div class="main-content">
          <p class="main-text">
            {{ messageContent.mainContent }}
          </p>
          <p class="desc-text" v-if="messageContent.descContent">
            {{ messageContent.descContent }}
          </p>
        </div>
      </template>
      <!-- 富文本-插入内容 -->
      <div
        v-else-if="messageContent.content"
        class="dialog-message-content"
        v-html="messageContent.content"
      />
      <slot name="content" />
    </div>
    <template v-if="messageContent.showCancelBtn || messageContent.showConfirmBtn" #footer>
      <div
        class="dialog-message-footer"
        :class="{
          'top-border': messageContent.showFooterBBorder
        }"
      >
        <RxkButton v-if="messageContent.showCancelBtn" @click="handleClose">
          {{ messageContent.cancelText || '取消' }}
        </RxkButton>
        <RxkButton
          v-if="messageContent.showConfirmBtn"
          type="primary"
          @click="confirm"
          :isLoading="isLoading"
        >
          {{ messageContent.confirmText || '确定' }}
        </RxkButton>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { WarningFilled, SuccessFilled, CircleCloseFilled } from '@element-plus/icons-vue'
import { RxkButton } from '@/components/common/RxkButton'
const loading = ref(false)
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  messageContent: {
    type: Object,
    default() {
      return {
        isDefault: true,
        mainContent: '确定要执行此操作吗？',
        descContent: '操作后数据无法撤销，请谨慎操作',
        title: '提示',
        content: '这是一条重要提示', // 也可传富文本，isDefault设置了true，不起作用，所以不用传此值
        cancelText: '取消',
        confirmText: '确定',
        showCancelBtn: true,
        showConfirmBtn: true,
        type: 'warn', // 类型，success 成功提示，error 异常提示，warn 警告提示
        showHeaderTBorder: false, // 是否显示头部操作栏底部边框
        showFooterBBorder: false // 是否显示底部操作栏顶部边框
      }
    }
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  confirmBtnFn: {
    type: Function,
    default: () => {}
  }
})
const emit = defineEmits(['update:visible', 'close', 'confirm', 'focus', 'change'])
const dialogVisible = computed({
  get() {
    return props.visible
  },
  set(val) {
    emit('update:visible', val)
  }
})
const handleClose = () => {
  emit('close')
}
const confirm = (fn: Fn) => {
  if (props.isLoading) {
    loading.value = true
    emit('confirm', () => {
      loading.value = false
      fn?.()
    })
  } else {
    emit('confirm')
  }
}
defineExpose({
  handleClose,
  confirm
})
</script>
<style lang="scss">
.dialog-message-overlay {
  .el-overlay-dialog {
    max-height: 90vh;
    overflow: hidden;
    height: auto;
  }
  .el-dialog__header {
    padding: 16px 24px;
    border-bottom: none;
    margin-right: 0;
    .el-dialog__headerbtn {
      top: 4px;
    }
    .el-dialog__title {
      font-weight: 400;
      font-family: 'Microsoft YaHei';
      line-height: 24px;
      font-size: 16px;
    }
  }
  .el-dialog__body {
    padding: 0;
    max-height: calc(90vh - 260px);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .el-dialog__footer {
    border: none;
    padding: 0;
    .el-button + .el-button {
      margin-left: 12px;
    }
    .dialog-message-footer {
      padding: 16px 24px;
      &.top-border {
        border-top: 1px solid #ebeef5;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.dialog-message-overlay {
  .dialog-message-content {
    width: 100%;
    padding: 24px;
    // padding-top: 48px;
    @include flex-center(row, normal, normal);
    .line {
      border-top: 1px solid #ebeef5;
      width: 100%;
      position: absolute;
      left: 0;
      top: 56px;
    }
    .warn-icon {
      font-size: 16px;
      margin-top: 3px;
      &.warn {
        color: #faad14;
      }
      &.success {
        color: #1dc95f;
      }
      &.error {
        color: #f75151;
      }
    }
    .main-content {
      margin-left: 8px;
      > p {
        padding: 0;
        margin: 0;
      }
      .main-text {
        color: #333333;
        font-size: 14px;
        font-family: 'Microsoft YaHei';
        text-align: left;
        letter-spacing: 0.7px;
        line-height: 22px;
      }
      .desc-text {
        color: #999999;
        font-size: 14px;
        font-weight: 400;
        font-family: 'Microsoft YaHei';
        line-height: 20px;
        letter-spacing: 0.7px;
        margin-top: 9px;
      }
    }
  }
}
</style>
